import { render, staticRenderFns } from "./DoseRecommendationTab.vue?vue&type=template&id=152bfa59&scoped=true&"
import script from "./DoseRecommendationTab.vue?vue&type=script&lang=js&"
export * from "./DoseRecommendationTab.vue?vue&type=script&lang=js&"
import style0 from "./DoseRecommendationTab.vue?vue&type=style&index=0&id=152bfa59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152bfa59",
  null
  
)

export default component.exports